var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsbChargingPort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 8.33333V3.83333C14.166 3.36662 14.166 3.13327 14.0752 2.95501C13.9953 2.79821 13.8678 2.67072 13.711 2.59082C13.5328 2.5 13.2994 2.5 12.8327 2.5H7.16602C6.69931 2.5 6.46595 2.5 6.28769 2.59082C6.13089 2.67072 6.00341 2.79821 5.92351 2.95501C5.83268 3.13327 5.83268 3.36662 5.83268 3.83333V8.33333M8.74935 5.83333V5M11.2493 5.83333V5M9.49935 17.5H10.4993C12.3662 17.5 13.2996 17.5 14.0127 17.1367C14.6398 16.8171 15.1498 16.3072 15.4693 15.68C15.8327 14.9669 15.8327 14.0335 15.8327 12.1667V9.66667C15.8327 9.19992 15.8327 8.96658 15.7418 8.78833C15.6619 8.6315 15.5345 8.50408 15.3777 8.42417C15.1994 8.33333 14.9661 8.33333 14.4993 8.33333H5.49935C5.03264 8.33333 4.79928 8.33333 4.62102 8.42417C4.46422 8.50408 4.33674 8.6315 4.25684 8.78833C4.16602 8.96658 4.16602 9.19992 4.16602 9.66667V12.1667C4.16602 14.0335 4.16602 14.9669 4.52932 15.68C4.84891 16.3072 5.35884 16.8171 5.98605 17.1367C6.69908 17.5 7.63251 17.5 9.49935 17.5Z",
    stroke: "#78787D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2227_232",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 10,
    width: 6,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8258 10H7.17578V15.65H12.8258V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2227_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4131 12.7666C11.4043 12.7347 11.3888 12.705 11.3677 12.6794C11.3466 12.6538 11.3204 12.633 11.2907 12.6183L10.4926 12.2228L10.7069 10.742C10.7139 10.6907 10.7038 10.6385 10.6782 10.5935C10.6526 10.5485 10.6128 10.5132 10.565 10.4931C10.5173 10.473 10.4643 10.4692 10.4142 10.4822C10.364 10.4953 10.3196 10.5246 10.2878 10.5655L8.63991 12.6842C8.61754 12.7128 8.60208 12.7461 8.59473 12.7817C8.58738 12.8172 8.58834 12.8539 8.59753 12.889C8.60792 12.9241 8.62599 12.9565 8.65041 12.9838C8.67484 13.0111 8.70503 13.0326 8.73878 13.0468L9.74401 13.4493L9.52978 14.9136C9.5225 14.9662 9.53319 15.0197 9.56011 15.0654C9.58703 15.1111 9.6286 15.1464 9.67809 15.1655C9.70568 15.177 9.73534 15.1826 9.7652 15.182C9.80397 15.1818 9.8421 15.172 9.87619 15.1535C9.91027 15.1351 9.93927 15.1084 9.96059 15.0761L11.3731 12.9573C11.393 12.9302 11.4069 12.8992 11.4138 12.8663C11.4207 12.8334 11.4204 12.7994 11.4131 12.7666Z",
    fill: "#78787D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsbChargingPort);
export default __webpack_public_path__ + "static/media/USB-Charging-port.b32729e2a48fbab75f1549dcfcbfefc5.svg";
export { ForwardRef as ReactComponent };